export default "__VITE_ASSET__BuRBp$EG__"